import { render, staticRenderFns } from "./platformArchive.vue?vue&type=template&id=3fad6fa6&"
import script from "./platformArchive.vue?vue&type=script&lang=js&"
export * from "./platformArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports